import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_7150_11569)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.707 6.29325L8.707 0.29325C8.316 -0.09775 7.684 -0.09775 7.293 0.29325L1.293 6.29325C1.105 6.48025 1 6.73525 1 7.00025V15.0002C1 15.5522 1.448 16.0002 2 16.0002H14C14.552 16.0002 15 15.5522 15 15.0002V7.00025C15 6.73525 14.895 6.48025 14.707 6.29325ZM8 5.00025C9.105 5.00025 10 5.89525 10 7.00025C10 8.10425 9.105 9.00025 8 9.00025C6.895 9.00025 6 8.10425 6 7.00025C6 5.89525 6.895 5.00025 8 5.00025ZM12 13.0002H4V11.0002H12V13.0002Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_7150_11569" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }